import axios from 'axios'

/**
 * Create a request to the server using Axios library
 * @param {String} url - Request URL
 * @param {String} method - Request method (GET/POST)
 * @param {Object} data - Request data
 * @param {Object} headers - Request headers
 * @return {Promise} - HTTP request
 */
const request = ({
    data,
    url,
    method = 'POST',
    headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'Accept-Language': document.documentElement.getAttribute('lang'),
    },
}) =>
    new Promise((resolve, reject) => {
        axios({
            data,
            url,
            method,
            headers,
        })
            .then(response => resolve({ ...response }))
            .catch(reject)
    })

export default request
